import { BaseStore } from 'fluxible/addons';

export const SearchResultState = {
  LOADING: 'LOADING',
  LOADED: 'LOADED',
  ERROR: 'ERROR'
};

class SearchStore extends BaseStore {

  constructor(dispatcher) {
    super(dispatcher);
    this.results = {};
  }

  handleResultLoading({ query, page }) {
    this.results[`${query}:${page}`] = {
      query,
      page,
      state: SearchResultState.LOADING
    };
    this.emitChange();
  }

  handleResultLoaded({ query, page, response }) {
    const result = this.results[`${query}:${page}`];
    result.state = SearchResultState.LOADED;
    result.response = response;
    this.emitChange();
  }

  handleResultLoadFailed({ query, page, err }) {
    const result = this.results[`${query}:${page}`];
    result.state = SearchResultState.ERROR;
    result.error = err;
    this.emitChange();
  }

  getResult({ query, page }) {
    return this.results[`${query}:${page}`];
  }

  dehydrate() {
    return {
      results: this.results
    };
  }

  rehydrate(state) {
    this.results = state.results;
  }

}

SearchStore.storeName = 'SearchStore';
SearchStore.handlers = {
  'SEARCH_RESULT_LOADING': 'handleResultLoading',
  'SEARCH_RESULT_LOAD_SUCCESS': 'handleResultLoaded',
  'SEARCH_RESULT_LOAD_FAILURE': 'handleResultLoadFailed'
};

export default SearchStore;
